import { isValidUsPhoneNumber } from "@/components/agents/setup/receptionist/phone-utils"
import { StepHeader, WizardLayout } from "@/components/agents/setup/shell"
import { Button } from "@/components/ui/button"

import { type CalendarConnect, HandoffFields } from "./fields"
import type { LeadResponderSetupStepProps } from "./types"

// IMP-469: booking and transfer are one decision — what to do with a lead
// who's ready for a human — so they share a step, mirroring the edit drawer's
// Handoff tab (same HandoffFields component).
export function HandoffStep({
  stepNumber,
  totalSteps,
  data,
  onUpdate,
  onNext,
  onBack,
  calendars,
}: LeadResponderSetupStepProps & { calendars: CalendarConnect }) {
  const numberValid =
    data.transfer_number.trim() !== "" &&
    isValidUsPhoneNumber(data.transfer_number)
  const bookingConfigured =
    data.booking_calendar !== "" && data.booking_event_type !== ""
  const canContinue =
    (!data.transfer_enabled || numberValid) &&
    (!data.booking_enabled || bookingConfigured)

  return (
    <WizardLayout
      footer={
        <>
          <Button variant="outline" onClick={onBack}>
            Back
          </Button>
          <Button onClick={onNext} disabled={!canContinue}>
            Continue
          </Button>
        </>
      }
    >
      <StepHeader
        eyebrow={`Step ${stepNumber} of ${totalSteps}`}
        title="How should I hand off leads?"
        description="When a lead is ready, I can connect them live or schedule an appointment. Otherwise, I'll wrap up the call and send you a summary."
      />
      <HandoffFields data={data} onUpdate={onUpdate} calendars={calendars} />
    </WizardLayout>
  )
}
